document.addEventListener("DOMContentLoaded", function() {
  (function($) {
    $("#search-toggler").on('click', toggleSearch);
    $("#search-toggler--mobile").on('click', toggleSearch);
    $(".mobile-top__close").on('click', function() {
      toggleSearch(true);
    });

    function toggleSearch(remove) {
        if ($("#nav-search-bar").hasClass("active") || remove == true) {
          //close
        $("#nav-search-bar").removeClass("active");
        $(".mobile-top__search").css('right', '15px'); // move magnifying glass
        $("#search-input").blur();
        } else {
          //open
          $("#nav-search-bar").addClass("active");
          $(".mobile-top__search").css('right', 'calc(85% + 15px)'); // move magnifying glass
          $("#search-input").focus();
        }
    }
  })(jQuery);
});
